import React from 'react';
import navProducts from '../Shared/navProducts';
import { Link } from 'react-router-dom';

function Navigation() {
  return (
    <div className="pt-20 font-tt-lakes">
      
      <div className="bg-marine-black text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Navigation Systems
            </h1>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Advanced navigation solutions for modern marine vessels
            </p>
          </div>
        </div>
      </div>

      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {navProducts.map((product) => (
            <Link
              key={product.id}
              to={`/products/navigation/${product.id}`}
              className="block"
            >
              <div
                key={product.id}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
               
                <div className="aspect-w-16 aspect-h-9">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-48 object-cover"
                  />
                  
                </div>

                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-marine-black mb-2">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {product.description}
                  </p>

                  
                  <div className="space-y-2">
                    <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                      Key Features
                    </h4>
                    <ul className="space-y-2">
                      {product.features.map((feature, index) => (
                        <li key={index} className="flex items-center text-sm text-gray-600">
                          <svg 
                            className="h-4 w-4 text-marine-red mr-2" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor"
                          >
                            <path 
                              strokeLinecap="round" 
                              strokeLinejoin="round" 
                              strokeWidth={2} 
                              d="M5 13l4 4L19 7" 
                            />
                          </svg>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>

                 
                  <div className="mt-6">
                    <button className="w-full bg-marine-red hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors duration-300 flex items-center justify-center space-x-2">
                      <span>Learn More</span>
                      <svg 
                        className="w-4 h-4" 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                      >
                        <path 
                          strokeLinecap="round" 
                          strokeLinejoin="round" 
                          strokeWidth={2} 
                          d="M9 5l7 7-7 7" 
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-marine-black mb-6">
              Need Technical Support?
            </h2>
            <p className="text-gray-600 mb-8">
              Our team of navigation experts is ready to help you choose the right solution for your vessel
            </p>
            <button className="bg-marine-red hover:bg-red-700 text-white px-8 py-3 rounded-lg transition-colors duration-300">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navigation;